/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function () {
  'use strict';
  var root = document.querySelector('[data-mapa-v2]');
  if (!root) return;
  var table = root.querySelector('[data-wyniki-tabela]');
  if (!table) return;
  var lang = (document.documentElement.lang || '').toLowerCase(), de = /^de(?:-|$)/i.test(lang), en = /^en(?:-|$)/i.test(lang), nl = /^nl(?:-|$)/i.test(lang);
  var game = root.getAttribute('data-gra') || '';
  var copy = null, ui = null;
  try {
    var configNode = document.getElementById('wyniki-konfig');
    var config = configNode ? JSON.parse(configNode.textContent || '{}') : {};
    copy = (config.T && config.T.mapa) || config.mapa || null;
    ui = config.T && config.T.marketUi || null;
  } catch (e) { copy = null; ui = null; }
  function uiText(key, fallback) { return ui && ui[key] ? ui[key] : fallback; }
  function format(template, values) {
    return String(template || '').replace(/%([1-9])/g, function (match, index) { var value = values[Number(index) - 1]; return value === undefined || value === null ? '' : String(value); });
  }
  function pluralForm(count) {
    if (/^pl(?:-|$)/i.test(lang)) {
      var last = count % 10, lastTwo = count % 100;
      if (count === 1) return 'one';
      return last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14) ? 'few' : 'many';
    }
    return count === 1 ? 'one' : 'many';
  }
  var headers = table.querySelectorAll('[data-wyniki-naglowek] [data-wyniki-number]');
  var observed = {};
  try {
    var store = JSON.parse(localStorage.getItem('pewniaki:moje-zestawy:v2') || '{}');
    var sets = store && store.games && Array.isArray(store.games[game]) ? store.games[game] : [];
    sets.forEach(function (set) { (set.numbers || []).forEach(function (n) { observed[n] = true; }); });
  } catch (e) { observed = {}; }

  var tools = document.createElement('div');
  tools.className = 'przyciski-rzad odstep-1';
  tools.innerHTML = '<span class="tekst-maly" data-mapa-obserwowane></span>';
  var bar = root.querySelector('.wyniki-tabela__pasek');
  if (bar) bar.insertAdjacentElement('afterend', tools);
  var observedText = tools.querySelector('[data-mapa-obserwowane]');
  var list = Object.keys(observed).map(Number).sort(function (a,b) { return a-b; });
  observedText.textContent = list.length ? ((uiText('saved_numbers', de ? jst("ui.9f86f8aa77d783a7") : (jst("pages_mapa_losowan_v2_js.d64267227a10")))) + list.join(', ')) : uiText('no_saved_numbers', de ? jst("ui.150fd403ab56dde0") : (jst("pages_mapa_losowan_v2_js.8fb016309f3e")));

  var panel = document.createElement('aside');
  var activeNumber = null;
  panel.className = 'karta karta--cicha mapa-liczba-panel';
  panel.setAttribute('data-mapa-panel', '');
  panel.setAttribute('hidden', '');
  root.querySelector('.tabela-scroll').insertAdjacentElement('afterend', panel);

  var tourStep = 0, tourTarget = null;
  var tourStart = document.createElement('button');
  tourStart.type = 'button'; tourStart.className = 'przycisk';
  tourStart.textContent = uiText('map_guide', de ? jst("ui.7bd9c2131d71f04a") : (jst("pages_mapa_losowan_v2_js.2ab6feca808e")));
  tools.appendChild(tourStart);
  var tour = document.createElement('div');
  tour.className = 'mapa-demo'; tour.hidden = true;
  tour.setAttribute('role', 'region');
  tour.setAttribute('aria-label', uiText('map_guide_aria', de ? jst("ui.eb6b4b04f664a54e") : (jst("pages_mapa_losowan_v2_js.1e9b0fd39a60"))));
  function finishTour() {
    if (tourTarget) tourTarget.classList.remove('mapa-demo-cel');
    tourStep = 0; tour.hidden = true; tourStart.focus();
  }
  function showStep(step) {
    if (tourTarget) tourTarget.classList.remove('mapa-demo-cel');
    tourStep = step;
    tourTarget = step === 1 ? root.querySelector('[data-wyniki-ile]') : step === 2 ? table.querySelector('[data-wyniki-naglowek]') : panel;
    if (!tourTarget) { finishTour(); return; }
    tourTarget.classList.add('mapa-demo-cel');
    var messages = ui && ui.map_guide_1 ? [ui.map_guide_1, ui.map_guide_2, ui.map_guide_3] : de ? [
      jst("ui.68b240eb29e0da49"),
      jst("ui.58b9ba329046fcfd"),
      jst("ui.421afeface259ed5")
    ] : en ? [
      jst("ui.db74281d5e7efac0"),
      jst("ui.1d9015279125f467"),
      jst("ui.0d9ce5f006d7c9ee")
    ] : [
      jst("pages_mapa_losowan_v2_js.literal.ff66cea08901"),
      jst("pages_mapa_losowan_v2_js.literal.92ec387d3e42"),
      jst("pages_mapa_losowan_v2_js.literal.f8e33ed2aa26")
    ];
    tour.innerHTML = jst("fragment.daa4f1b2f4c28877")+(uiText('map_step',de?jst("fragment.c0f684317a911ff8"):jst("pages_mapa_losowan_v2_js.24ec62834147")))+step+jst("fragment.2b75ecda58b64dd9")+messages[step-1]+'</p><div class="przyciski-rzad">'+(step===1?'<button type="button" class="przycisk" data-demo-next>'+uiText('map_next',de?jst("ui.1e14bdf34c3bdead"):jst("pages_mapa_losowan_v2_js.4b66bcfff3a8"))+'</button>':'')+'<button type="button" class="przycisk" data-demo-close>'+(step===3?uiText('map_finish',de?jst("ui.25d52d7e86650364"):jst("pages_mapa_losowan_v2_js.379c42d7b21f")):uiText('map_close_guide',de?jst("ui.58744c33df89b63b"):jst("pages_mapa_losowan_v2_js.8aed77b73f0f")))+'</button></div>';
    (step===3 ? panel : root.querySelector('.tabela-scroll')).insertAdjacentElement('beforebegin',tour);
    tour.hidden = false;
    tour.querySelector('[data-demo-close]').onclick = finishTour;
    var next = tour.querySelector('[data-demo-next]');
    if(next) next.onclick = function(){showStep(2);};
    tour.scrollIntoView({block:'nearest',behavior:'auto'});
    tour.querySelector('[data-demo-text]').focus({preventScroll:true});
  }
  tourStart.onclick = function(){
    if(root.hasAttribute('data-wyniki-wybieranie')) {
      var toggle=root.querySelector('[data-wyniki-utworz]');
      if(toggle) toggle.click();
    }
    showStep(1);
  };
  root.addEventListener('keydown',function(e){if(e.key==='Escape' && tourStep)finishTour();});

  function currentRange() {
    if (window.PewniakiWynikiZakres) return window.PewniakiWynikiZakres.requested;
    var current = root.querySelector('[data-wyniki-zakres][aria-current="true"]');
    return current ? parseInt(current.getAttribute('data-wyniki-zakres'), 10) : 25;
  }
  function urlSet(number) {
    var u = new URL(location.href); u.searchParams.set('liczba', number); u.searchParams.set('okno', currentRange());
    if(u.searchParams.has('ile')) u.searchParams.set('ile',currentRange());
    history.replaceState(null, '', u.pathname + '?' + u.searchParams.toString() + u.hash);
  }
  function dateText(iso) {
    var date = new Date(iso);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString(de ? 'de-DE' : (nl ? 'nl-NL' : (jst("pages_mapa_losowan_v2_js.4c54b4893add"))), {
      timeZone: de ? 'Europe/Berlin' : (nl ? 'Europe/Amsterdam' : 'Europe/Warsaw'), day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  }
  function openNumber(number, reveal) {
    activeNumber = number;
    var selected = window.PewniakiWynikiZakres && window.PewniakiWynikiZakres.draws || [], n = selected.length, hits = 0, last = [], partners = {};
    for (var i=0; i<n; i++) {
      if (selected[i].numbers.indexOf(number)<0) continue;
      hits++; if (last.length < 5) last.push(dateText(selected[i].drawn_at));
      selected[i].numbers.forEach(function(partner){if(partner!==number)partners[partner]=(partners[partner]||0)+1;});
    }
    var top = Object.keys(partners).sort(function(a,b){ return partners[b]-partners[a] || a-b; }).slice(0,5).map(function(x){ return '<span role="listitem" class="mapa-partner"><span class="kula kula--'+game.replace(/[^a-z-]/g,'')+'">'+Number(x)+'</span><span class="tekst-maly">'+format(copy && copy['times_'+pluralForm(partners[x])],[partners[x]])+'</span></span>'; });
    var length = Math.min(12, n), rhythmRows = [];
    if (length >= 4) {
      var sample = selected.slice(0, length), target = sample.map(function(draw){ return draw.numbers.indexOf(number) >= 0; });
      if (target.some(Boolean)) for (var candidate = 1; candidate <= headers.length; candidate++) {
        if (candidate === number) continue;
        var matches = 0, candidateHits = 0;
        sample.forEach(function(draw, index){ var hit = draw.numbers.indexOf(candidate) >= 0; if(hit) candidateHits++; if(hit === target[index]) matches++; });
        if (candidateHits && matches / length >= 0.75) rhythmRows.push({number:candidate, matches:matches});
      }
    }
    rhythmRows.sort(function(a,b){return b.matches-a.matches || a.number-b.number;});
    var rhythms = rhythmRows.slice(0,5).map(function(row){ return '<span role="listitem" class="mapa-partner"><span class="kula kula--'+game.replace(/[^a-z-]/g,'')+'">'+row.number+'</span><span class="tekst-maly">'+format(copy && copy.rhythm_match,[row.matches,length])+'</span></span>'; });
    var occurrenceKey = 'occurrences_' + pluralForm(hits);
    panel.innerHTML = '<div class="przyciski-rzad"><h3>'+format(copy && copy.number,[number])+'</h3><button class="przycisk przycisk--maly" type="button" data-mapa-zamknij aria-label="'+(copy && copy.close || '')+'">×</button></div>'+
      '<p><strong>'+format(copy && copy[occurrenceKey],[hits,n])+'</strong></p>'+
      '<p>'+(copy && copy.latest || '')+(last.join(', ') || '—')+'</p>'+
      '<p>'+(copy && copy.neighbors || '')+'</p><div class="mapa-partnerzy" role="list">'+(top.join('') || '—')+'</div>'+
      '<p>'+(copy && copy.rhythms || '')+'</p><div class="mapa-partnerzy" data-mapa-rytmy role="list">'+(rhythms.join('') || (copy && copy.rhythm_empty || '—'))+'</div>'+
      '<p class="tekst-maly">'+format(copy && copy.rhythm_method,[length])+'</p>'+
      '<p class="tekst-maly">'+(copy && copy.history || '')+'</p>';
    panel.removeAttribute('hidden');
    panel.querySelector('[data-mapa-zamknij]').onclick = function(){ activeNumber=null;panel.setAttribute('hidden',''); };
    urlSet(number);
    if(tourStep===2) showStep(3);
    else if(reveal) panel.scrollIntoView({block: 'nearest', behavior: 'auto'});
  }
  headers.forEach(function (th) {
    var number = Number(th.getAttribute('data-wyniki-number'));
    th.tabIndex = 0; th.setAttribute('role','button');
    th.setAttribute('aria-label', uiText('number_stats_aria', de ? jst("fragment.bd7fd6119f0df5de") : (jst("pages_mapa_losowan_v2_js.eeefcfcdfee2"))) + number);
    if (observed[number]) th.classList.add('mapa-v2__obserwowana');
  });
  // Delegacja obejmuje również kopię z zamienionymi osiami. W trybie kuponu
  // wybór przechwytuje wspólny szkic; zwykłe kliknięcie nadal pokazuje statystyki.
  function numberAction(e) {
    var th = e.target.closest('[data-wyniki-number]');
    if (!th || !root.contains(th) || root.hasAttribute('data-wyniki-wybieranie')) return;
    if (e.type === 'keydown' && e.key !== "Enter" && e.key !== ' ') return;
    if (e.type === 'keydown') e.preventDefault();
    openNumber(Number(th.getAttribute('data-wyniki-number')), true);
  }
  root.addEventListener('pewniaki:wyniki-liczba', function(e) {
    var number = Number(e.detail && e.detail.number);
    if (Number.isInteger(number) && number >= 1 && number <= headers.length) openNumber(number, true);
  });
  root.addEventListener('click', numberAction);
  root.addEventListener('keydown', numberAction);
  var url = new URL(location.href), initial = parseInt(url.searchParams.get('liczba'),10);
  var pendingInitial = initial > 0 && initial <= headers.length;
  function showInitial() {
    if (!pendingInitial || !window.PewniakiWynikiZakres) return;
    pendingInitial=false;openNumber(initial);
  }
  root.addEventListener('pewniaki:wyniki-zakres',function(){
    if (pendingInitial) showInitial(); else if(activeNumber!==null) openNumber(activeNumber);
  });
  showInitial();
}());
